import { render, staticRenderFns } from "./InteractiveManagementIndex.vue?vue&type=template&id=383f0c72&scoped=true"
import script from "./InteractiveManagementIndex.vue?vue&type=script&lang=js"
export * from "./InteractiveManagementIndex.vue?vue&type=script&lang=js"
import style0 from "./InteractiveManagementIndex.vue?vue&type=style&index=0&id=383f0c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383f0c72",
  null
  
)

export default component.exports